export default __webpack_public_path__ + "static/dashboards_screenshot-crop_dashboard-ui-3c6e26b9b8df3599cfa27ff671b6d9e0.webp";